import { render, staticRenderFns } from "./GameRoundDetails.vue?vue&type=template&id=ba4a4022&scoped=true"
import script from "./GameRoundDetails.vue?vue&type=script&lang=js"
export * from "./GameRoundDetails.vue?vue&type=script&lang=js"
import style0 from "./GameRoundDetails.vue?vue&type=style&index=0&id=ba4a4022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a4022",
  null
  
)

export default component.exports